import TestimonialContainer from "../../../components/pages/other/Testimonial";

const Testimonial = () => {
  return <TestimonialContainer />;
};

export default Testimonial;
